module.exports = __webpack_public_path__ + "img/201.11fff44c.jpg";